export default __webpack_public_path__ + "static/media/book-and-magic.83ba0b4a.svg";